import classNames from "classnames";
import React from "react";

interface IProps {
  children: React.ReactNode;
  className?: string;
  loading?: boolean;
}

export default function Bracket({ children, className, loading }: IProps) {
  return (
    <>
      {children ? (
        <div className={classNames("flex w-fit gap-0.5", className)}>
          <span>[</span>
          {loading ? (
            <span className="relative mr-3">
              {children}
              <span className="animate-typing absolute left-full inline-block overflow-x-hidden whitespace-pre">
                ...
              </span>
            </span>
          ) : (
            children
          )}
          <span>]</span>
        </div>
      ) : null}
    </>
  );
}
